import { useState } from "react";
import { Download } from "lucide-react";
import { GuideModal } from "./GuideModal";

export const GuideSection = () => {
  const [guideModalOpen, setGuideModalOpen] = useState(false);

  return (
    <section id="guide" className="section bg-[#0F172A]" data-testid="guide-section">
      <div className="max-w-4xl mx-auto text-center">
        <div className="gold-line mx-auto" />
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-serif">
          The Next Chapter Guide
        </h2>
        <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          Download our comprehensive guide with information that can be printed and referenced as you plan your next move. It's full of helpful tips, checklists, and resources designed specifically for North Carolina homeowners.
        </p>
        
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-sm">
          <Download className="text-[#D4AF37] mx-auto mb-6" size={48} />
          <h3 className="text-xl text-white font-semibold mb-4">
            Free Download — No Obligation
          </h3>
          <p className="text-white/70 mb-2">
            Available in English and Spanish
          </p>
          <p className="text-white/70 mb-6">
            Get instant access to your guide
          </p>
          <button 
            onClick={() => setGuideModalOpen(true)}
            className="btn-primary"
            data-testid="download-guide-button"
          >
            <Download size={18} />
            Download the Next Chapter Guide
          </button>
          <p className="text-sm text-white/50 mt-4">
            PDF format • Easy to print • Just enter your name and email
          </p>
        </div>
      </div>

      <GuideModal isOpen={guideModalOpen} onClose={() => setGuideModalOpen(false)} />
    </section>
  );
};
